<!--
 * @Descripttion: 
 * @version: 
 * @Author: youquan.yu
 * @Date: 2020-08-11 09:52:56
 * @LastEditors: youquan.yu
 * @LastEditTime: 2020-08-26 14:13:24
-->
<template>
    <div class="wrapper">
        <v-head style="z-index:2000;"></v-head>
        <div class="ContentDiv">
            <div class="ContentPageDiv" :class="{'content-collapse':collapse}">
                <a-breadcrumb >
                    <home-outlined />
                    <a-breadcrumb-item>  {{ routerPath }}</a-breadcrumb-item>
                </a-breadcrumb>
                <transition name="move" mode="out-in">
                    <keep-alive :include="tagsList">
                        <router-view></router-view>
                    </keep-alive>
                </transition>          
            </div>            
            <v-footer></v-footer>
        </div>
        <div id="components-back-top-demo-custom">
        <a-back-top>
        <div class="ant-back-top-inner">
                UP
            </div>
            </a-back-top>
            Scroll down to see the bottom-right
            <strong style="color: #1088e9"> blue </strong>
            button.
        </div>
    </div>
</template>

<script>
    import vHead from './Header.vue';
    import vFooter from './Footer.vue';
    export default {
        data(){
            return {
                tagsList: [],
                collapse: false,
                routerPath: this.$route.path
            }
        },
        components:{
            vHead,vFooter
        },
        created(){
            // if (localStorage.getItem("userToken")) {
                
            // }else {
            //     this.$router.replace({path: "/login"})
            // }
        },
        watch: {
            $route(to,from){
                this.routerPath = to.path
            }
        },
    }
</script>
<style scoped>
    .ContentDiv {
        width: 100%;
        text-align: center;
        background-color: #F5F5F5;
        position: absolute;
    }
    .ContentPageDiv {
        margin-top: 15px;
        padding-bottom: 30px;
        text-align: left;
        width: 1120px;
        display: inline-block;
    }
    #components-back-top-demo-custom .ant-back-top {
        bottom: 100px;
    }
    #components-back-top-demo-custom .ant-back-top-inner {
        height: 40px;
        width: 40px;
        line-height: 40px;
        border-radius: 4px;
        background-color: #1088e9;
        color: #fff;
        text-align: center;
        font-size: 20px;
    }
</style>
